import { useMutation } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";
import type { Energy } from "@services/services.types";

import type { GetPod, GetPodParams } from "./apiEcms.types";

const getPod = async ({ energy, podSerial }: GetPodParams) => {
  const { data } = await apiEcmsHttp.get<GetPod>(
    energy === "ELEC"
      ? `/electricity-delivery-points/${podSerial}`
      : `/gas-delivery-points/${podSerial}`,
  );

  return data;
};

export const useGetPod = ({
  energy,
  podSerial,
}: {
  energy: Energy | null;
  podSerial: string;
}) =>
  useMutation<GetPod, unknown, GetPodParams>({
    mutationKey: [QUERY_KEYS.PERIMETER_POD_DATA, energy, podSerial],
    mutationFn: () => getPod({ energy, podSerial }),
  });
